import { useSelector } from 'react-redux'
import { Box, CircularProgress } from '@mui/material'
import { ListResponseType } from 'services/types'
import {
  RECOMMENDATION_INSIGHT,
  TBakersRecommendation,
} from 'types/models/BakersRecommendations'
import { TModuleKey } from 'store/slices/insightsTabsSlice'
import { selectTabs } from 'store/selectors/insightsTabsSliceSelectors'
import { RecommendationInsightCard } from '../recommendationsInsights/recommendationInsightCard'
import { CardTitle } from '../../../../../../components'
import { Container } from '../../../../../Shipment/pages/IncomingDeliveriesDetails/components/ConsistencyResult/ConsistencyResult.styled'
import * as sxStyles from '../../AnalyticsDetails.styled'

interface IRecommendationsSectionProps {
  recommendations: ListResponseType<TBakersRecommendation>
  isRecommendationLoading: boolean
  selectedDeliveryId: string
  moduleKey: TModuleKey
}

export const RecommendationsSection = ({
  recommendations,
  isRecommendationLoading,
  selectedDeliveryId,
  moduleKey,
}: IRecommendationsSectionProps) => {
  const tabs = useSelector(selectTabs(moduleKey, selectedDeliveryId))

  const isBothOpen = tabs.insights && tabs.recommendations
  const maxHeight = isBothOpen ? 400 : 'calc(100vh - 200px)'
  return (
    <Box sx={sxStyles.sectionContainer}>
      <Container>
        <Box px="16px">
          <CardTitle title="Recommendations" />
        </Box>
        <Box
          sx={{
            ...sxStyles.expandableBox,
            maxHeight,
          }}
        >
          {recommendations ? (
            recommendations.results.map((recommendation) => (
              <RecommendationInsightCard
                key={recommendation.guid}
                cardData={recommendation}
                type={RECOMMENDATION_INSIGHT.recommendation}
                selectedDeliveryId={selectedDeliveryId}
              />
            ))
          ) : isRecommendationLoading ? (
            <CircularProgress color="primary" />
          ) : null}
        </Box>
      </Container>
    </Box>
  )
}
